module.exports = __webpack_public_path__ + "static/img/kitchen-thumb.1490598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/kitchen-thumb.jpg
// module id = l+tT
// module chunks = 0